import { ChangeDetectionStrategy, Component, HostBinding, Input, output } from '@angular/core';

import { markEventAsHandled } from '@blaze-runtime/engine-util';
import { ViewportMode } from '@blaze-shared/elements-domain';

import { CalendarDateFormat } from '../../elements/calendar/calendar.models';
import { CalendarDatesViewComponent } from '../calendar-dates-view';

@Component({
  selector: 'blaze-calendar-header',
  templateUrl: './calendar-header.component.html',
  styleUrls: ['./calendar-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CalendarHeaderComponent {
  isCalendarVisibleChange = output<boolean>();
  nextDay = output<void>();
  nextPeriod = output<void>();
  previousDay = output<void>();
  previousPeriod = output<void>();

  @Input() calendar: CalendarDatesViewComponent | undefined;
  @Input() isCalendarVisible = false;
  @Input() selectedCalendarDate = new Date();
  @Input() viewportMode: ViewportMode | undefined;

  private _dateFormat = CalendarDateFormat.LongDate;

  @Input() set dateFormat(dateFormat: CalendarDateFormat) {
    this._dateFormat =
      dateFormat === CalendarDateFormat.FullDate ? CalendarDateFormat.LongDate : dateFormat;
  }

  get dateFormat(): CalendarDateFormat {
    return this._dateFormat;
  }

  @HostBinding('class.mobile') get isMobile(): boolean {
    return this.viewportMode === 'mobile';
  }

  openYearSelectionView(event: Event): void {
    markEventAsHandled(event);
    if (!this.calendar) {
      console.warn('Missing CalendarMonthView component');
      return;
    }

    this.isCalendarVisible = true;
    this.isCalendarVisibleChange.emit(this.isCalendarVisible);

    this.calendar.openYearSelectionView();
  }

  toggleCalendarVisibility(event: Event): void {
    markEventAsHandled(event);
    this.isCalendarVisible = !this.isCalendarVisible;
    this.isCalendarVisibleChange.emit(this.isCalendarVisible);
  }

  selectPreviousDate(event: Event): void {
    markEventAsHandled(event);
    if (this.isCalendarVisible) {
      this.previousPeriod.emit();
    } else {
      this.previousDay.emit();
    }
  }

  selectNextDate(event: Event): void {
    markEventAsHandled(event);
    if (this.isCalendarVisible) {
      this.nextPeriod.emit();
    } else {
      this.nextDay.emit();
    }
  }
}
